import React,{useState,useEffect,useRef} from 'react';

const PlayListTile=({alimPlaylist})=>{
    const [albumArt, setAlbumArt] = useState(alimPlaylist.parts[0].thumbnail.url);
    const [defaultAlbumArt, setDefaultAlbumArt] = useState(alimPlaylist.parts[0].thumbnail.url);
    const [playListURL,setPlayListURL]=useState(null);
    const [opacity, setOpacity] = useState(1);
    const [encodedPlaylist,setEncodedPlaylist]=useState(null);
    const timeoutRef = useRef(null); // Ref to store the timeout

    const handleMouseEnter = (event) => {
        // Get the new album art from the parent <li> element
        const newAlbumArt = event.currentTarget.getAttribute('data-album-art');

        // Only execute if the new album art is different from the current album art and not the default
        if (albumArt !== newAlbumArt && newAlbumArt !== defaultAlbumArt) {
            setOpacity(0); // Start fade out

            // Clear any existing timeout
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            // Set a new timeout to change the image
            timeoutRef.current = setTimeout(() => {
                setAlbumArt(newAlbumArt); // Set the new album art
                setOpacity(1); // Start fade in after changing the image
            }, 300); // Match this to your CSS transition duration
        }
    };

    const handleMouseLeave = () => {
        // Only execute if the album art is not already the default album art
        if (albumArt !== defaultAlbumArt) {
            setOpacity(0); // Start fade out

            // Clear any existing timeout
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            // Set a new timeout to change the image
            timeoutRef.current = setTimeout(() => {
                setAlbumArt(defaultAlbumArt); // Reset to the default album art
                setOpacity(1); // Start fade in after changing the image
            }, 300); // Match this to your CSS transition duration
        }
    };

    // Cleanup on component unmount
    useEffect(() => {
        // Extract video IDs
        const videoIds = alimPlaylist.parts.map(part => part.resourceId.videoId);

        // Encode the video IDs into a query string (comma-separated)
        const encodedVideoIds = encodeURIComponent(videoIds.join(','));

        setEncodedPlaylist(encodedVideoIds)

        setPlayListURL(`/quran-videos/zamzam/play-playlist?vidId=${alimPlaylist.parts[0].resourceId.videoId}&alimPlaylist=${encodedVideoIds}`)

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    
    return(
        <div className="grid md:grid-cols-12 gap-0 md:gap-10 alim-text-color-style">
            <div className="md:col-span-6 flex items-center">
                <div className='aspect-ratio-box h-fit'>
                    <img src={`${albumArt}`} title={alimPlaylist.surahName} alt={`Thumbnail for ${alimPlaylist.surahName}`} className='transition-opacity duration-500 opacity-100' style={{opacity:opacity}}/>
                </div>
                
            </div>  
            <div className="md:col-span-6 table flex items-center">
                <div className="table-cell align-middle pt-8 md:pt-0" style={{ wordBreak: "break-word" }}>
                    <h2 className="mb-5 lg:mb-8">{alimPlaylist.surahName}</h2>
                    <p className="opacity-75 mt-5">Contents:</p>
                    <ul className="opacity-75 mt-5">
                        {
                            alimPlaylist.parts.map((part,partIndex)=>{
                                return(
                                    <li key={partIndex} className='my-2 flex items-center hover:text-deep-red'
                                        onMouseEnter={(e)=>{handleMouseEnter(e)}}
                                        onMouseLeave={(e)=>{handleMouseLeave(e)}}
                                        data-album-art={part.thumbnail.url}
                                    >
                                        <div
                                            title="Recite this Ayah"
                                            className="btn-recite-icon playBtns cursor-pointer media-icons play-img-elem w-[22px] h-[22px] mr-2"
                                        ></div>
                                        <a href={`/quran-videos/zamzam/play-playlist?vidId=${part.resourceId.videoId}&alimPlaylist=${encodedPlaylist}`}>{part.title}</a>
                                    </li>
                                )
                            })
                        }
                    </ul>
                    <a href={playListURL!==null?playListURL:"#"} className="bg-deep-red py-3 px-5 mt-5 inline-block red-button-hover-style text-white"> Play now </a>
                </div> 
            </div>     
        </div>
    );
}

export default PlayListTile;